import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
/**
 * This class stores query and its parameters
 */
export var Query = /*#__PURE__*/_createClass(function Query(query, parameters) {
  _classCallCheck(this, Query);
  this.query = query;
  this.parameters = parameters;
  this["@instanceof"] = Symbol.for("Query");
});